import { default as PlaintextSerializer } from 'slate-plain-serializer-old';

export default PlaintextSerializer;
